module.exports = __webpack_public_path__ + "img/platform1.f07b1fb2.png";